export enum ComposedViewEnum {
  Home = 'Home',
  GO = 'GO',
}
